import SearchIcon from "@mui/icons-material/Search";
import TuneIcon from "@mui/icons-material/Tune";
import AddToQueueIcon from "@mui/icons-material/AddToQueue";
import { Badge, Button, Paper, Stack } from "@mui/material";
import { GridChild, GridContainer } from "../../../components";
import { ReactElement, useRef } from "react";
import BarcodeReaderIcon from "@mui/icons-material/BarcodeReader";
import { styleConstants } from "../../../utils/colors";

const MobileMenuButton = ({
  icon,
  label,
  onClick,
  count,
  to,
  component = "button",
}: {
  icon: ReactElement;
  label: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  count?: number;
  to?: string;
  component?: React.ElementType;
}) => {
  return (
    <GridChild size={{ xs: 3 }}>
      <Button
        onClick={onClick}
        sx={{ borderRadius: 0, width: "100%", fontSize: "0.6rem" }}
        className="mobile-menu-button"
        variant="text"
        color="secondary"
        component={component}
        to={to}
      >
        <Stack justifyContent={"center"} alignItems="center" gap="5px">
          <Badge invisible={count === 0} badgeContent={count} color="primary">
            {icon}
          </Badge>
          <span>{label}</span>
        </Stack>
      </Button>
    </GridChild>
  );
};

export const TableMobileMenu = ({
  setSearchAnchor,
  setFilterAnchor,
  openScanner,
  openModal = () => {},
  filters,
  newLabel = "New",
}: {
  setSearchAnchor: () => void;
  openScanner?: () => void;
  setFilterAnchor: () => void;
  openModal?: () => void;
  filters: any[];
  newLabel?: string;
}) => {
  const menuRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <div
        className="mobile-menu-spacer"
        style={{
          height: `calc(${styleConstants.mobileTableMenuHeight} + env(safe-area-inset-bottom))`,
          width: "100%",
          flexShrink: 0,
          marginTop: "0.8rem",
        }}
      />
      <Paper
        ref={menuRef}
        square
        elevation={8}
        sx={{
          height: `calc(${styleConstants.mobileTableMenuHeight} + env(safe-area-inset-bottom))`,
          pb: "env(safe-area-inset-bottom)",
          boxSizing: "border-box",
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: (theme) => theme.zIndex.appBar + 2,
          display: {
            xs: "block",
            md: "none",
          },
        }}
        className="controls-bar mobile bottom"
      >
        <GridContainer spacing={0} className="mobile-menu-grid">
          <MobileMenuButton
            icon={<BarcodeReaderIcon />}
            label="Scan"
            onClick={openScanner}
          />
          <MobileMenuButton
            onClick={setFilterAnchor}
            icon={<TuneIcon />}
            label="Filter"
            count={filters.length}
          />
          <MobileMenuButton
            onClick={setSearchAnchor}
            icon={<SearchIcon />}
            label="Search"
          />
          <MobileMenuButton
            icon={<AddToQueueIcon />}
            label={newLabel}
            onClick={openModal}
          />
        </GridContainer>
      </Paper>
    </>
  );
};

export default TableMobileMenu;
